/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {DictionaryItem} from '../models/DictionaryItem';
import type {Error} from '../models/Error';

export interface GetEntityTypes$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getEntityTypesRequest = createAction<PayloadData<void>>('GET_ENTITY_TYPES__GET_ENTITY_TYPES__REQUEST');
export const getEntityTypesSuccess = createAction<PayloadData<Array<DictionaryItem>>>('GET_ENTITY_TYPES__GET_ENTITY_TYPES__SUCCESS');
export const getEntityTypesFailure = createAction<PayloadData<Error, void, true>>('GET_ENTITY_TYPES__GET_ENTITY_TYPES__FAILURE');

export const getEntityTypesActions = [
    getEntityTypesRequest,
    getEntityTypesSuccess,
    getEntityTypesFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getEntityTypes = (config?: GetEntityTypes$Config) => {
    return {
        CALL_API: {
            types: getEntityTypesActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/dictionaries/entity-type`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

